<table
  tuiTable
  [columns]="columns"
>
  <thead>
    <tr tuiThGroup>
      <ng-container *ngFor="let header of columns">
        <th
          *tuiHead="header"
          tuiTh
          >{{ headers[header] }}</th
        >
      </ng-container>
    </tr>
  </thead>
  <tbody
    *tuiLet="data | tuiTableSort as sortedUsers"
    tuiTbody
    [data]="sortedUsers"
  >
    <tr
      *ngFor="let item of sortedUsers; let index = index"
      (click)="handleOnClick(item)"
      tuiTr
    >
      <ng-container *ngFor="let header of columns">
        <td
          *tuiCell="header"
          tuiTd
          >{{ item[header] }}</td
        >
      </ng-container>
    </tr>
  </tbody>
</table>
